import { useQuery } from "@tanstack/react-query";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import { oneOnboardingApi } from "libs/api";
import { useParams } from "router";

export const useProfileDataApi = () => {
    const { lang, propertyId } = useParams("/:lang/list-my-property/onboard/:propertyId/profile");

    const { data, isLoading, isError, isFetching } = useQuery({
        queryKey: [TanstackQueryKey.GetProfileData, lang, propertyId],
        queryFn: () => oneOnboardingApi.getProfileData(lang, Number(propertyId)).then((res) => res.data),
        staleTime: 0,
    });

    return {
        data,
        isLoading: isLoading || isFetching,
        isError,
    };
};
